// import React, { Component } from 'react'
// import { isEmpty } from 'lodash';
// import PropTypes from 'prop-types';

// import asyncRoute from '../../../helpers/hoc/asyncRoute';
// import Error from '../error';

// const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));

// export default  class index extends Component {
//   render() {
//     const { onChange, onBlur, setting, submited, touched, error, value, accept, upload, fileRef=null } = this.props;
//     const { labelLayout = 'col-sm-4' } = setting
//     return (
//       <div className="form-group row">
//         {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{' '} {setting.required && <span className="arterisk"> * </span>}</label>}
//         <div className={setting.displayLayout}>
//           <div className="row">
//             <div className="col-sm-6">
//               <input type="file"
//                 id={setting.key}
//                 className={isEmpty(error) ? "form-control" : "form-control has-error"}
//                 onChange={onChange}
//                 onBlur={onBlur}
//                 name={setting.key}
//                 accept={accept}
//                 ref={fileRef}
//               // placeholder={setting.placeholder}
//               />
//             </div>
//             <div className="col-sm-6">
//               <button type="button" onClick={() => {
//                 upload({ target: { name: setting.key } })
//               }} className="btn btn-primary">Upload</button>
//             </div>
//           </div>
//           {(submited || touched) && (<Error setting={setting} error={error} />)}
//         </div>
//         {setting.tooltip && <Tooltip text={setting.tooltip} />}
//       </div>
//     )
//   }
// }

// // ----* input propTypes set *----
// index.propTypes = {
//   onChange: PropTypes.func.isRequired,
//   onBlur: PropTypes.func.isRequired,

//   // -----* setting PropTypes *----
//   setting: PropTypes.shape({
//     required: PropTypes.bool,
//     label: PropTypes.string,
//     key: PropTypes.string,
//     type: PropTypes.string,
//     placeholder: PropTypes.string,
//     tooltip: PropTypes.string,
//     touched: PropTypes.object
//   }),
// }



import React, { forwardRef } from 'react'
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import Error from '../error';

const Tooltip = asyncRoute(() => import('../../../components/FormElements/ToolTip'));

const index = forwardRef((props, ref = ()=>{}) => {
  const { onChange, onBlur, setting, submited, touched, error, value, accept, upload } = props;
  const { labelLayout = 'col-sm-4' } = setting
  return (
    <div className="form-group row">
      {setting.label && <label htmlFor={setting.key} className={`${labelLayout} col-form-label`}>{setting.label}{" "}{(setting.required)?"":<><br/><span className="small" style={{color:"#1925238a"}}>Optional</span></>}</label>}
      <div className={setting.displayLayout}>
        <div className="row">
          <div className="col-sm-6">
            <input type="file"
              id={setting.key}
              className={isEmpty(error) ? "form-control" : "form-control has-error"}
              onChange={onChange}
              onBlur={onBlur}
              name={setting.key}
              defaultValue=''
              accept={accept}
              ref={ref}
            // placeholder={setting.placeholder}
            />
          </div>
          <div className="col-sm-6">
            <button type="button" onClick={() => {
              upload({ target: { name: setting.key } })
            }} className="btn btn-primary">Upload</button>
          </div>
        </div>
        {(submited || touched) && (<Error setting={setting} error={error} />)}
      </div>
      {setting.tooltip && <Tooltip text={setting.tooltip} />}
    </div>
  )
})

export default index
// ----* input propTypes set *----
index.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,

  // -----* setting PropTypes *----
  setting: PropTypes.shape({
    required: PropTypes.bool,
    label: PropTypes.string,
    key: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    tooltip: PropTypes.string,
    touched: PropTypes.object
  }),
}
